import './Header.css';

function Header() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <img
          className="site-header__banner"
          src="/banner_utt_2025.png"
          alt="Trường Đại học Công nghệ Giao thông Vận tải"
        />        
      </div>
    </header>
  );
}

export default Header;
